import React from 'react';
import { connect } from 'react-redux';
import { flagUnsavedTabs } from '../../redux/actions';
import ModalConfirm from './ModalConfirm';

const ModalConfirmDiscardChanges = ({ props, ...rest }) => {
  const { message, onConfirm } = props;
  const getListOfUnsavedChanges = (messageContent) => (
    <div className="discardChanges">
      <span>You have unsaved changes in:</span>
      <ul>
        {Array.isArray(messageContent) ? (
          messageContent.map((message, index) => (
            <li key={`change-${index}`}>{message}</li>
          ))
        ) : (
            <li>{messageContent}</li>
          )}
      </ul>
    </div>
  );

  const defaultMessage = () => (
    <div className="discardChanges">
      <p>All unsaved changes will be discarded if you choose to continue.</p>
      <br />
      <p>Are you sure you want to discard changes?</p>
    </div>
  );

  const messageToDisplay = message
    ? getListOfUnsavedChanges(message)
    : defaultMessage();

  const confirmDiscardChanges = () => {
    rest.flagUnsavedTabs();
    rest.onClose();
  };

  return (
    <ModalConfirm
      message={messageToDisplay}
      onConfirm={onConfirm}
      onClose={confirmDiscardChanges}
      onConfirmLabel="Discard changes"
    />
  );
};

export default connect(null, { flagUnsavedTabs })(ModalConfirmDiscardChanges);
